export default __webpack_public_path__ + "static/media/order.d34ef92a.png";